import { SVG, SVGProps } from './svg'

export function IconRemove(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M5.5 13a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13Z" />
    </SVG>
  )
}
